import React, { Component } from 'react';
import HttpRunner from '../query';
import perms from '../../../utils/permissions';
import urlHandler from '../../../utils/urlHandler';
import examples from '../../../utils/examples';

class DocAcronymEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        })            
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 id="person" className="heading-1">Acronym</h3>
                    <div className="description">
                        Finch for Text is able to recognize and extract defined acronyms that appear in text. This includes actual 
                        acronyms and a looser definition of acronyms which include text that provides an abbreviated label 
                        (short form) and a description of that abbreviation (long form). Acronym extractions may be of any 
                        varying type (diseases, groups, drugs, technologies, regulations, etc.) although Finch For Text does 
                        not provide the specific type at this time. When an acronym is found in text, all mentions, including 
                        the short form are tagged.. If another entity type is mentioned along with an acronym or abbreviation, 
                        that entity will not be tagged as ACRONYM entity type. It will retain its entity type such as 
                        ORGANIZATION or GEO. This way if the acronym "United States of America (USA)" occurs, it will remain 
                        a GEO entity type even though it is also an acronym.
                    </div>
                    <br/>
                    <div className="description">An acronym entity will be represented by the following attributes:</div>

                    <table className="table-wrapper">
                        <thead className="table-header">
                        <tr>
                            <th>Attribute </th>
                            <th>Meaning </th>
                            <th>Type </th>
                            <th>Constraints </th>
                            <th>Notes </th>
                        </tr>
                        </thead>

                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">longForm</td>
                            <td className="meaning">The long form of the acronym, which describes the short form.</td>
                            <td className="type">String</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes"></td>
                        </tr>
                        <tr>
                            <td className="attribute">shortForm</td>
                            <td className="meaning">The short form of the acronym.</td>
                            <td className="type">String</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes"></td>
                        </tr>
                        </tbody>
                    </table>

                    <h4 className="heading-2">Example</h4>

                    <div className="example-content dt">
                        Global supercomputer leader Cray Inc. today announced a comprehensive set of Artificial 
                        Intelligence (AI) products and programs that will empower customers to learn, start, and scale 
                        their deep learning (DL) initiatives.<br/>
                        <br/>
                        As AI and DL continue to transform entire industries and scientific disciplines, 
                        Cray is leveraging its supercomputing expertise, technologies, and best practices to 
                        advance DL adoption.
                    </div>
                    <HttpRunner example="acronym1" 
                        query="enrich" 
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_ACRONYM) : null}
                    />
                </div>
            </div>
        );
    }
}

export default DocAcronymEntity;